<div class="footer">
    Copyright <a href="http://www.movisat.com" target="_blank">MOVISAT</a> ©{{anno}}
    <span style="float: right;"><sub>Versión {{version}}</sub></span>
</div>